export default "__VITE_ASSET__BOQ20ufv__"